import { useMemo } from 'react';
import { useCostCeiling } from '../cost-ceiling/index.js';
import { LoadingState, h } from '../index.js';
// What a calculation on the case needs besides its vouchers, documents and
// policy.
export const useCaseConditions = (caseId) => {
    const costCeilingLoader = useCostCeiling(caseId);
    // The loader is a new object on every render; its data is not.
    const costCeiling = h.hasData(costCeilingLoader)
        ? costCeilingLoader.data
        : null;
    const error = h.isError(costCeilingLoader) ? costCeilingLoader.error : null;
    return useMemo(() => {
        if (error != null) {
            return { loadingState: LoadingState.Error, error };
        }
        if (costCeiling == null) {
            return { loadingState: LoadingState.Loading };
        }
        return { loadingState: LoadingState.Loaded, data: { costCeiling } };
    }, [error, costCeiling]);
};
//# sourceMappingURL=index.js.map